import(/* webpackMode: "eager" */ "/app/packages/schoolfeed/app/not-found.jsx");
